import { useEffect, useState } from "react";
import { myCompany } from "../api/directory";

// مفاتيح الميزات لكل شركة — مع تحديث تلقائي عند التركيز/الإشعار/كل 90 ثانية
// حتى تظهر ميزة يفعّلها مالك المنصة فوراً دون الحاجة لإغلاق التطبيق (Fix TestFlight).
const DEFAULTS = { duties: false, api_webhooks: true, accounting: false, live_map: false, cash_transfers: false, fx_rates: false, payroll_cycle: false, service_requests: true, qr_checkin: false, sales: false, purchases: false, warehouse: false, penalties: false, kpi: false, bonuses: false, company_backup: false, _ready: false };
const TTL = 90000;
let cached = null;
let cachedAt = 0;
let inflight = null;
const listeners = new Set();
const notify = () => listeners.forEach((fn) => fn(cached));

const load = () => {
  inflight = inflight || myCompany();
  return inflight
    .then((data) => {
      cached = { ...DEFAULTS, ...(data?.features || {}), _ready: true };
      cachedAt = Date.now();
      notify();
    })
    .catch(() => {})
    .finally(() => { inflight = null; });
};

export const useFeatures = () => {
  const [features, setFeatures] = useState(cached);
  useEffect(() => {
    if (!cached || Date.now() - cachedAt > TTL) load();
    const fn = (val) => setFeatures(val);
    listeners.add(fn);
    return () => listeners.delete(fn);
  }, []);
  return features || DEFAULTS;
};

export const refreshFeatures = () => { cached = null; cachedAt = 0; return load(); };
export const clearFeatureCache = () => { cached = null; cachedAt = 0; };

if (typeof document !== "undefined") {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible" && (!cached || Date.now() - cachedAt > TTL)) load();
  });
  window.addEventListener("features:refresh", () => refreshFeatures());
  setInterval(() => { if (cached && document.visibilityState === "visible") load(); }, TTL);
}
